import list from '@/mixins/list';
import baseUrl from '../../utils/api';
import merge from 'webpack-merge';
import dayjs from 'dayjs';

export default {
  name: 'Statistical',
  inject: ['reload'],
  mixins: [list],
  data() {
    return {
      loading: false,
      excelLoading: false,
      id: this.$route.query.id || undefined,
      code: this.$route.query.code || undefined,
      type: this.$route.query.type || undefined,
      factor: this.$route.query.factor || undefined,

      list_live: {},
      list_record: {},
      list_replay: {},
      list_course: {},
      columnsLiveAll: [
        {
          index: 0,
          label: '上课时间',
          width: '180px',
          disabled: true,
          formatter: (row) => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time;
          },
        },
        {
          index: 1,
          label: '上课时长',
          formatter: (row) => {
            const time = this.$setting.setTime(row.all_liveroom_second);
            return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
          },
        },
        { index: 2,
          label: '实际上课时长',
          width: '130px',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.living_duration) {
              const time = this.$setting.setTime(row.living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        {
          index: 3,
          label: '上课状态',
          formatter: (row) => {
            const status = {
              1: '未开始',
              2: '上课中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return status[row.status];
          },
        },
        { index: 4, prop: 'teacher.name', label: '授课老师' },
        { index: 5, prop: 'teacher_mobile', label: '上课账号', width: '120px' },
        {
          index: 6,
          label: '课程名称',
          width: '130px',
          formatter: (row) => {
            const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';
            const name = park ? row.course_ware_packet_auth.packet.name : '--';
            return name || '--';
          } },
        { index: 7, prop: 'course_name', label: '课件名称', width: '110px' },
        {
          index: 8,
          label: '扣费形式',
          formatter: (row) => {
            const status = {
              0: '--',
              1: '金币',
              2: '会员',
              3: '商品',
              4: '课程包账号',
              5: '年服务',
              6: '体验期',
              7: '课程包次数',
            };
            return status[row.fee_type];
          },
          width: '100px',
        },
        { index: 9,
          prop: 'packet_number_consume',
          label: '耗课次数',
          // formatter: (row) => {
          //   const isNum = row.packet_auth_type === 2 ? 1 : 0;
          //   return isNum;
          // }
        },
        { index: 10, prop: 'liveroom_classes', label: '上课班级', width: '150px' },
        { index: 11,
          label: '班级学生数',
          formatter: row => row.student_count || 0 },
        { index: 12, prop: 'be_present', label: '出勤' },
        { index: 13, prop: 'present_logs', label: '有效参与学生数' },
        {
          index: 14,
          label: '上课端口',
          formatter: (row) => {
            const status = {
              0: '--',
              6: '教师端',
              14: '教学平台',
              15: 'AI播放器',
              16: 'SDK',
            };
            return status[row.access_client_id];
          },
          width: '100px',
        },
        { index: 15, prop: 'sdk_request', label: 'sdk调用次数', width: '110px' },
        { index: 16, prop: 'teacher_voice_count', label: '语音评测次数' },
        // {
        //   index: 4,
        //   label: '上课类型',
        //   formatter: (row) => {
        //     const status = {
        //       1: '班级直播间',
        //       2: '链接直播间',
        //       3: '线下课',
        //     };
        //     return status[row.type];
        //   },
        //   width: '100px',
        // },
        {
          index: 17,
          prop: 'living_duration',
          label: '老师上课时长',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.living_duration) {
              const time = this.$setting.setTime(row.living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        {
          index: 18,
          prop: 'student_living_duration',
          label: '学生上课时长',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.student_living_duration) {
              const time = this.$setting.setTime(row.student_living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        { index: 19,
          label: '账号有效期',
          width: '110px',
          formatter: (row) => {
            const time = row.course_ware_packet_auth ? row.course_ware_packet_auth.auth_expire_time : '--';
            return time || '--';
          } },
        // { index: 19,
        //   prop: 'living_duration',
        //   label: '直播实际时长',
        //   formatter: (row) => {
        //     let diff = '00:00:00';
        //     if (row.living_duration) {
        //       const time = this.$setting.setTime(row.living_duration);
        //       diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
        //     }
        //     return diff;
        //   },
        // },

      ],
      excelFiles: { // excel导出文件参数对应
        0: 'live_time', // 上课时间
        1: 'lesson_time_period', // 上课时长
        2: 'living_duration', // 实际上课时长
        3: 'live_status', // 上课状态
        4: 'teacher_name', // 授课老师
        5: 'teacher_mobile', // 上课账号
        6: 'packet_name', // 课程名称
        7: 'course_name', // 课件名称
        8: 'fee_type', // 扣费形式
        9: 'number_consume', // 耗课次数
        10: 'liveroom_classes', // 上课班级
        11: 'student_count', // 班级学生数
        12: 'be_present', // 出勤
        13: 'effective_student', // 有效参与学生数
        14: 'access_client', // 上课端口
        15: 'sdk_request', // sdk调用次数
        16: 'teacher_voice_count', // 语音评测次数
        17: 'living_duration', // 老师上课时长
        18: 'student_living_duration', // 学生上课时长
        19: 'account_period', // 账号有效期
      },
      columnsLive: [],
      columnsRecord: [],
      columnsReplay: [],
      columnsCourse: [
        { prop: 'code', label: '订单号' },
        { prop: 'commodities.name', label: '购买商品' },
        { prop: 'commodities.code', label: '商品编号' },
        { prop: 'created_at', label: '购买时间' },
        { prop: 'user.mobile', label: '购买账户' },
        { prop: 'discount_coin', label: '消费金币' },
      ],
      apiUrl: '',
      api: '/api/liveroom?is_show_teacher=1&order[created_at]=desc',
      // api: '/api/liveroom?is_show_teacher=1&equal[status]=3&order[created_at]=desc',
      domain: '',
      api_record: '',
      api_replay: '',
      api_course: '',
      searchList: {
        access_client_id: [
          { value: 6, name: '教师端' },
          { value: 14, name: '教学平台' },
          { value: 15, name: 'AI播放器' },
          { value: 16, name: 'SDK' },
        ],
        status: [
          { value: 1, name: '未开始' },
          { value: 2, name: '上课中' },
          { value: 3, name: '已结束' },
          { value: 4, name: '缺课' },
          { value: 5, name: '已取消' },
        ],
      },

      dialogDetail: { // 查看详情
        show: false,
        data: {
          commodities: {
            make_school: {},
          },
          user: {},
        },
      },

      activeName: this.$route.query.active || 'school_teaching',
      transfer: null,
      transfer_page: 1,
      transfer_per_page: 10,
    };
  },
  computed: {
    searchArrLive() {
      const column = [
        { prop: 'auth_packet_name', label: '课程名称' },
        { prop: 'name', label: '课件名称' },
        { prop: 'teacher_name', label: '授课老师' },
        { prop: 'teacher_mobile', label: '上课账号' },
        // { prop: 'search_school_name', label: '校区名称' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: this.searchList.status,
          componentType: 'AppSearchStatus',
          searchType: 'status',
          placeholder: '请选择上课状态',
        },
        {
          selectValue: this.searchList.access_client_id,
          componentType: 'AppSearchStatus',
          searchType: 'access_client_id',
          placeholder: '请选择上课端口',
        },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '互动课件' },
        //     { value: 1, name: '云盘文件' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择课件类型'
        // },
        // {
        //   selectValue: [
        //     { value: 1, name: '是' },
        //     { value: 0, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_playback',
        //   placeholder: '请选择录制情况'
        // },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '是' },
        //     { value: 1, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择回放情况'
        // },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    searchArrRecord() {
      const column = [
        { prop: 'name', label: '视频名称' },
        { prop: 'record_teacher_name', label: '录制人' },
        { prop: 'id', label: '视频号' },
        { prop: 'liveroom_number', label: '教室编号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    searchArrReplay() {
      const column = [
        { prop: 'search_name', label: '用户名称' },
        { prop: 'search_mobile', label: '账号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    searchArrCourse() {
      const column = [
        { prop: 'name', label: '商品名称' },
        { prop: 'mobile', label: '购买账号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    role() {
      return this.$store.state.user;
    },
    school() {
      return this.$store.state.school;
    },
  },
  created() {
    const _at = this.$route.query.created_at;

    this.api_course = `${baseUrl
    }/api/course/commodities/orders`
      + '?order[created_at]=desc'
      + '&in[status][]=2'
      + '&in[status][]=3'
      + `&equal[school_id]=${String(this.$store.state.choicesSchool.id)}`;

    if (_at) {
      const _sat = _at.split('-');

      this.api_course +=
        `&between[created_at][]=${`${_at}-01 00=00=00`}` +
        `&between[created_at][]=${`${_at}-${(new Date(_sat[0], _sat[1], 0)).getDate()} 23=59=59`}`;
    }

    if (this.code) {
      this.activeName = this.code;
    }

    const type = {
      // 线上课程
      online_course: {
        api: '/api/liveroom?is_show_teacher=1&equal[status]=3&order[id]=desc&in[type][]=1&in[type][]=2&in[course_type][]=2',
        searchArr: {
          type: [
            { value: 1, name: '班级直播' },
            { value: 2, name: '链接直播' },
          ],
          course_type: [
            { value: 2, name: 'AI双师课件' },
          ],
        },
      },
      // 线上课件
      online_course_ware: {
        api: '/api/liveroom?is_show_teacher=1&equal[status]=3&order[id]=desc&in[type][]=1&in[type][]=2&in[course_type][]=1&in[course_type][]=3',
        searchArr: {
          type: [
            { value: 1, name: '班级直播' },
            { value: 2, name: '链接直播' },
          ],
          course_type: [
            { value: 1, name: 'AI课件' },
            { value: 3, name: '互动课件' },
          ],
        },
      },
      // 线下课程
      offline_course: {
        api: '/api/liveroom?is_show_teacher=1&equal[status]=3&order[id]=desc&in[type][]=3&in[course_type][]=2',
        searchArr: {
          type: [
            { value: 3, name: '线下课' },
          ],
          course_type: [
            { value: 2, name: 'AI双师课件' },
          ],
        },
      },
      // 线下课件
      offline_course_ware: { // status直播间状态:1=未开始;2=直播中;3=已结束;4=缺课;5=已取消
        api: '/api/liveroom?is_show_teacher=1&equal[status]=3&order[id]=desc&in[type][]=3&in[course_type][]=1&in[course_type][]=3',
        searchArr: {
          type: [
            { value: 3, name: '线下课' },
          ],
          course_type: [
            { value: 1, name: 'AI课件' },
            { value: 3, name: '互动课件' },
          ],
        },
      },
    };
    if (this.type) {
      this.api = type[this.type].api;
      this.searchList = type[this.type].searchArr;
    }
    if (this.factor && this.factor === 'factor') {
      this.apiUrl = `${baseUrl}/api/service/agent/liveroom/${this.id}?is_show_teacher=1&equal[status]=3&order[id]=desc`;
      this.api_record = `${baseUrl}/api/service/agent/record/${this.id}?&order[id]=desc`;
      this.api_replay = `${baseUrl}/api/service/agent/replay/${this.id}?&order[id]=desc`;
    } else if (this.id && this.id !== 'null') {
      this.school.forEach((item) => {
        if (item.id === Number(this.id)) {
          this.apiUrl = `${this.$checkHttp()}${item.domain}${this.api}`;
          this.domain = `${this.$checkHttp()}${item.domain}`;
          this.api_record = `${this.domain}/api/record?order[id]=desc`;
          this.api_replay = `${this.domain}/api/replay?order[id]=desc`;
        }
      });
    } else {
      this.apiUrl = `${this.$checkHttp()}${this.$store.state.choicesSchool.domain}${this.api}`;
      this.domain = `${this.$checkHttp()}${this.$store.state.choicesSchool.domain}`;
      this.api_record = `${this.domain}/api/record?order[id]=desc`;
      this.api_replay = `${this.domain}/api/replay?order[id]=desc`;
    }
    this.initColum();
    this.columnsRecord = [
      { prop: 'liveroom_number', label: '教室编号' },
      { prop: 'name', label: '视频名称' },
      { prop: 'id', label: '视频号' },
      {
        label: '资源存储大小',
        formatter: row => this.$setting.getFileSize(row.resource_size),
      },
      {
        label: '录制时间',
        width: '170px',
        formatter: row => `${row.start_time} - ${row.end_time}`,
      },
      {
        label: '录制时长',
        formatter: (row) => {
          const time = this.$setting.setTime(row.video_seconds);
          return `${time.hourTime}:${time.min}:${time.sec}`;
        },
      },
      { prop: 'record_teacher_name', label: '录制人' },
      {
        label: '录制金额',
        show: this.factor !== 'factor',
        formatter: row => this.$setting.toDecimal(row.bill_record_amount, 2),
      },
    ];
    this.columnsReplay = [
      // { prop: 'student_name', label: '用户名称' },
      {
        label: '学生或老师名字',
        formatter: row => row.student_name || row.staff_name,
      },
      {
        prop: 'student_mobile',
        label: '手机号',
        formatter: row => row.student_mobile || row.staff_mobile,
      },
      { prop: 'record_id', label: '视频号' },
      {
        label: '观看时长',
        width: '170px',
        formatter: (row) => {
          const time = this.$setting.setTime(row.watch_seconds);
          return `${time.hourTime}:${time.min}:${time.sec}`;
        },
      },
      { prop: 'start_time', label: '观看开始时间' },
      {
        label: '金额',
        show: this.factor !== 'factor',
        formatter: row => this.$setting.toDecimal(row.bill_replay_amount, 2),
      },
    ];
  },
  methods: {
    // 初始选择项
    initColum() {
      const initColumn = [];
      const sdkState = this.$store.state.schoolSdkInfo.sdk_enable;
      const indexOff = sdkState ? [1, 5, 10, 11, 12, 13, 19] : [1, 5, 10, 11, 12, 13, 15, 16, 19];
      this.columnsLiveAll.forEach((item) => {
        if (indexOff.indexOf(item.index) === -1) {
          initColumn.push(item);
        }
      });
      this.columnsLive = initColumn;
    },
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    // 选择列表字段
    checkedColumns(val) {
      const data = [];
      val.forEach((item) => {
        this.columnsLiveAll.forEach((v) => {
          if (v.label === item) {
            data.push(v);
          }
        });
      });
      data.sort((a, b) => a.index - b.index);
      this.$nextTick(() => {
        this.columnsLive = data;
      });
    },
    handleClick() {
      this.$router.replace({
        query: merge({ page: 1, per_page: 10, active: this.activeName }),
      });
    },
    // 确认授权
    onSubmit() {
      console.log(1);
    },
    // 导出excel
    excelExport(str) {
      const filesArr = [];
      this.columnsLive.forEach((v) => {
        filesArr.push(this.excelFiles[v.index]);
      });
      const flies = filesArr.join();
      const api = `${str}&action=export_excel&excel_fields=${flies}`;
      this.excelLoading = true;
      this.$http.get(api, {
        responseType: 'blob',
      }).then((res) => {
        this.$setting.saveAs(res, '上课统计');
      }).finally(() => {
        this.excelLoading = false;
      });
    },
    // 上课统计详情
    StatisticalClass(row, tab) {
      let id = '';
      if (tab === 'record' || tab === 'replay') {
        id = row.liveroom_id;
      } else {
        id = row.id;
      }
      this.$router.push(`/statistical/class/${id}?typeId=${this.id}&activeName=${tab}`);
    },

    // 购买课程消费统计 - 详情
    courseDetail(_id) {
      this.$http.get(`${baseUrl}/api/course/commodities/orders/${_id}`).then((res) => {
        this.dialogDetail.data = res.data;
        this.dialogDetail.show = true;
      });
    },

    searchCall(arr = [], sp = false) {
      let _between = '';
      let _like = '';
      let _likes = [];

      if (!sp) {
        this.transfer_page = 1;
        this.transfer_per_page = 10;

        this.$router.replace({
          query: merge(this.$route.query, { page: 1, per_page: 10, active: this.activeName }),
        });
      }

      arr.forEach((val) => {
        if (/between/.test(val)) {
          _between = val.replace(/:/g, '=');
        } else if (/like/.test(val)) {
          _like = val.replace(/:/g, '=');
          _likes = val.split(':');
        }
      });

      this.loading = true;

      if (_likes[1]) {
        switch (_likes[0]) {
          case 'like[name]':
            this.$http.get(`${baseUrl}/api/course/commodities?${_like}`).then((res) => {
              const _arr = [];
              res.items.forEach(val => _arr.push(`in[commodities_id][]=${val.id}`));

              this.searchCallSp(`&${_arr.join('&')}${_between ? `&${_between}` : ''}`, arr, !_arr.length);
            }).catch(() => {
              this.loading = false;
            });
            break;
          case 'like[mobile]':
            this.$http.get(`/api/staff?like[mobile]=${_likes[1]}`).then((res) => {
              this.searchCallSp(`&equal[users_id]=${res.items.length ? res.items[0].uuid : ''}${_between ? `&${_between}` : ''}`, arr);
            }).catch(() => {
              this.loading = false;
            });
            break;
        }
      } else if (_between) {
        this.searchCallSp(`&${_between}`, arr);
      } else {
        this.searchCallSp('');
      }
    },

    searchCallSp(_query = '', _search = [], _empty = false) {
      if (_empty) {
        this.list_course = [];
        this.loading = false;
        return;
      }

      if (_search.length) {
        this.transfer = (obj) => {
          obj.page && (this.transfer_page = obj.page);
          obj.per_page && (this.transfer_per_page = obj.per_page);

          this.searchCall(_search, true);
        };
      } else {
        this.transfer = null;

        this.$router.replace({
          query: merge(this.$route.query, { page: 1, per_page: 10, active: this.activeName }),
        });
      }

      this.$http.get(`${this.api_course}${this.transfer ? `&page=${this.transfer_page}&per_page=${this.transfer_per_page}` : ''}${_query}`).then((res) => {
        this.list_course = res;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/Statistical/index.js